export const PrinterStatusCode = {
  Ok: 'ok',
  Error: 'error',
  Warning: 'warning',
  Undefined: 'undefined'
} as const
export type PrinterStatusCode = (typeof PrinterStatusCode)[keyof typeof PrinterStatusCode]

export const PrinterStatusSeverity = {
  Off: 0,
  Info: 1,
  Warning: 2,
  Error: 3
}
export type PrinterStatusSeverity =
  (typeof PrinterStatusSeverity)[keyof typeof PrinterStatusSeverity]
